import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('RQSMANAGEMENT', [
    'VIEW',
    'INFO',
    'HEADER',
    'FILTER_FORM'
])
